var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#b7b7b7;stroke-miterlimit:10;stroke-width:0.85px;}.cls-3{fill:#b7b7b7;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.7,
    cy: 4.06,
    r: 2.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.2,9.51c.41-.43.84-.89,1.29-1.33a3.72,3.72,0,0,1,.45.33l-1.61,1.92a1,1,0,0,1,0,.17c0,.13,0,.25,0,.38H8.41a5.56,5.56,0,0,0,1.23,1.35.87.87,0,0,0,.84,0,5.93,5.93,0,0,0,2.25-4.55A4.08,4.08,0,0,0,9,7l-.38.14A4,4,0,0,1,10.2,9.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,6.27a3.74,3.74,0,0,0-1.76,0l-.31.09a10.37,10.37,0,0,0-1,.38,3.2,3.2,0,0,1,.78.4L9,7a4.08,4.08,0,0,1,3.7.8,5.93,5.93,0,0,1-2.25,4.55.87.87,0,0,1-.84,0A5.56,5.56,0,0,1,8.41,11H7.63a6.32,6.32,0,0,0,1.94,2.14,1,1,0,0,0,.94.06,6.79,6.79,0,0,0,2.92-6A22.72,22.72,0,0,0,11,6.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.49,8.18c-.45.44-.88.9-1.29,1.33a4.64,4.64,0,0,1,.13.92l1.61-1.92A3.72,3.72,0,0,0,11.49,8.18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.17,9.82a8.51,8.51,0,0,1-.42-2.41c0-.06.06-.08.06-.14.4-.16.7-.36,1.06-.51a3,3,0,0,0-1.13-.23,3.86,3.86,0,0,0-3.6,4.07c0,.13,0,.25,0,.38H7.63s0,0,0-.07A5.84,5.84,0,0,1,7.17,9.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.33,10.87a5.18,5.18,0,0,1-.52-1.09,6.74,6.74,0,0,1-.36-2l.33-.22a5.84,5.84,0,0,1,.87-.43,3.2,3.2,0,0,0-.78-.4l-1.12.47v.18a8.28,8.28,0,0,0,.36,2.37,5.44,5.44,0,0,0,.45,1.09l.07.11h.78A.76.76,0,0,1,8.33,10.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10,9.72c-.53.09-.82-1.11-1.5-.16.54.4,1.05.76,1.58,1.16l.24-.29a4.64,4.64,0,0,0-.13-.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.bfafeaf9bc4f9b5131a322d5b4a851c3.svg";
export { ForwardRef as ReactComponent };